import { z } from 'zod';
import { accountFieldSchemas } from '@/features/account/shared/types/account-field-schemas';

export const loginFormSchema = z.object({
  email: accountFieldSchemas.buildEmail(),
  password: accountFieldSchemas.buildRequiredPasswordField({
    requiredMessage: 'errors.passwordRequired',
  }),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
